
import { Component, Vue, Prop, Emit, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { iStatisticDetail, iStatisticArea, iNetbarDetail } from '@/interface/result';
import { getAreaDetail } from '@/api/statistics';
import moment from 'moment';
import LogUtils from 'panda-log';
import ChartLine from '@/components/_chart_line.vue';

@Component({
  components: { ChartLine },
})
export default class DataDetail extends Mixins(PageQuery) {
  @Prop() detailInfo!: {};
  @Emit() private goback() {}

  private start!: any;
  private end!: any;
  private dates = [new Date(new Date().getTime() - 3600 * 1000 * 24 * 90), new Date()];
  private detail = {};
  private timeX = [];
  private dataA = [];
  private dataB = [];

  private chartVisible = false;

  private dateTable = [
    // {
    //   date: 1585152000,
    //   total_length: 100,
    //   advanced_length: 50,
    //   standard_length: 20,
    //   total_connect: 30,
    //   advanced_connect: 12,
    //   standard_connect: 54,
    // },
  ];

  dateHandler(e: any) {
    this.chartVisible = false;
    this.start = moment(e[0]).unix();
    this.end = moment(e[1]).unix() + (24 * 60 * 60 - 1);
    this.getNetbarDetail();
  }

  // 获取表格数据
  async getNetbarDetail() {
    try {
      const detailParams: iStatisticDetail = {
        start: this.start,
        end: this.end,
        areaid: (this.detail as iStatisticArea).id,
      };
      const res = await getAreaDetail({ ...detailParams, ...this.page_query });
      if (res) {
        this.dateTable = res.data.list;
        this.total = res.data.total;
        // 给折线图数据赋值。。。
        const _tempX = res.data.list.map((el: iNetbarDetail) => moment(el.date * 1000).format('MM-DD'));
        const _tempA = res.data.list.map((el: iNetbarDetail) => el.total_length);
        const _tempB = res.data.list.map((el: iNetbarDetail) => el.total_connect);

        this.timeX = JSON.parse(JSON.stringify(_tempX)).reverse();
        this.dataA = JSON.parse(JSON.stringify(_tempA)).reverse();
        this.dataB = JSON.parse(JSON.stringify(_tempB)).reverse();
        this.chartVisible = true;
      }
    } catch (error) {
      LogUtils.debug(error);
    }
  }

  created() {
    this.detail = JSON.parse(JSON.stringify(this.detailInfo));
    LogUtils.debug('🥞', this.detail);
    const { start, end } = this.detail as any;
    this.dates = [new Date(start * 1000), new Date(end * 1000)];
    this.start = moment(start * 1000).unix();
    this.end = moment(end * 1000).unix();
    this.pageFn = this.getNetbarDetail;
    this.getNetbarDetail();
  }
}
